import { EnvConfiguration } from './models';

const envProduction: EnvConfiguration = {
  AdminApiBaseUrl: 'https://muchobor-v2-api.azurewebsites.net/v1/admin',
  CoreApiBaseUrl: 'https://muchobor-v2-api.azurewebsites.net/v1',
  LeagueApiBaseUrl: 'https://muchobor-v2-api.azurewebsites.net/v1/league',
};
export default envProduction;
